import { clientId } from "./constants";
import "./propertyRenderers";
import "./appLinks";
import "./ticketViews";

export const shopFloorWalkRoutes = [
  {
    path: "/shop-floor-walk",
    name: "sfwDashboardList",
    component: () => import("@shared/shopFloorWalk/views/SFWDashboard.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/shop-floor-walk/:dashboardId",
    name: "sfwDashboardDetail",
    props: true,
    component: () =>
      import("@shared/shopFloorWalk/views/SFWDashboardDetail.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-assets",
    name: "sfwAssets",
    component: () => import("@shared/shopFloorWalk/views/SFWAssetListView.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-assets/:template/edit/:id?",
    name: "sfwAssetDetail",
    props: true,
    component: () =>
      import("@shared/shopFloorWalk/views/SFWAssetDetailView.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-walkthrough",
    name: "sfwWalkThrough",
    component: () =>
      import("@shared/shopFloorWalk/views/SFWWalkThroughView.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-walk-history",
    name: "sfwOrderHistory",
    component: () => import("@shared/shopFloorWalk/views/SFWOrderListView.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-walk-history/:template/edit/:id?",
    name: "sfwOrderHistoryDetail",
    props: true,
    component: () => import("@shared/shopFloorWalk/views/SFWOrderDetail.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/my-tickets",
    name: "sfwMyTickets",
    component: () => import("@shared/shopFloorWalk/views/SFWMyTickets.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/create",
    name: "sfwTicketCreate",
    component: () => import("@shared/shopFloorWalk/views/SFWTicketCreate.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/search",
    name: "sfwTicketSearch",
    component: () => import("@shared/shopFloorWalk/views/SFWTicketSearch.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/:id",
    name: "sfwTicketDetail",
    props: true,
    component: () => import("@shared/shopFloorWalk/views/SFWTicketDetail.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/:id/history",
    name: "sfwTicketHistory",
    props: true,
    component: () => import("@shared/shopFloorWalk/views/SFWTicketHistory.vue"),
    meta: {
      appClientId: clientId,
    },
  },
];
